module.exports = __webpack_public_path__ + "static/media/xepelin-celebration.104db736.gif";